import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoggedInGuard } from '../guards/logged-in-guard.service';

import { OnboardingComponent } from './onboarding/onboarding.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { MachineDetailsComponent } from './machine-details/machine-details.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { SubmittedComponent } from './submitted/submitted.component';
import { TermsComponent } from './terms/terms.component';

const routes: Routes = [
  {
    path: 'onboarding',
    component: OnboardingComponent,
    canActivate: [LoggedInGuard],
    children: [
      {
        path: '',
        canActivateChild: [LoggedInGuard],
        children: [
          { path: 'machine-details', component: MachineDetailsComponent },
          { path: 'bank-details', component: AccountDetailsComponent },
          { path: 'submitted', component: SubmittedComponent },
          { path: 'terms', component: TermsComponent },
          { path: '', component: CompanyDetailsComponent },
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OnboardingRoutingModule { }
